export default "__VITE_ASSET__D8d8NR4n__"